export enum LANGUAGES {
    "en" = "en"
}

export const DEFAULT_LANGUAGE: string = LANGUAGES.en;

export const defaultNS: string = "translation";